import React, { useEffect, useState, useRef } from "react";
import { Spinner } from "reactstrap";
import { injectIntl } from "react-intl";

import { useFetch } from "../Base/Hooks/fetch";
import PageDisplay from "../Base/PageDisplay/PageDisplay";
import FormBuilder from "../Base/Forms/FormBuilder";
import formSetup from "./formSetup";
import countryCodes from "../../config/countryCodes";

const EditLeagues = (props) => {
  const { title, history, match, intl, updateState } = props;
  const { formatMessage } = intl;
  const [refreshData, setRefreshData] = useState(true);
  const [currentLeague, setCurrentLeague] = useState(null);
  const pageRef = useRef();
  const { error, loading, data } = useFetch(
    "/v1/" + match.params.sport + "/o/" + match.params.organizationId + "/leagues/" + match.params.leagueId,
    "",
    refreshData
  );
  const LookupData = [];
  LookupData["regionTypes"] = ["INTERNATIONAL", "NATIONAL", "INTERSTATE", "STATE", "LOCAL"];

  LookupData["countryCodes"] = countryCodes;

  useEffect(() => {
    if (data) {
      setRefreshData(false);
      setCurrentLeague(data.data[0]);
    }
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if (match) {
      updateState("orgId", match.params.organizationId);
      updateState("sport", match.params.sport);
    }
    // eslint-disable-next-line
  }, [match]);

  function reloadData() {
    setRefreshData(true);
  }

  return (
    <PageDisplay
      title={formatMessage({
        id: "league.update",
        defaultMessage: "Update League"
      })}
      error={error}
      pageTitle={currentLeague && currentLeague.nameLocal + " -" + title}
      ref={pageRef}
      history={history}
    >
      {loading && <Spinner size="md" color="orange" />}
      {data && (
        <div>
          <h4>{currentLeague && currentLeague.nameLocal}</h4>
          {currentLeague && (
            <FormBuilder
              form="EditLeague"
              action={reloadData}
              formSetup={formSetup}
              formData={currentLeague}
              pageRef={pageRef}
              lookupData={LookupData}
            />
          )}
          {error}
        </div>
      )}
    </PageDisplay>
  );
};

export default injectIntl(EditLeagues);
